@if (data$ | async; as data; ) {
  <div class="flex flex-col gap-8">
    <div>
      @if (data.feedItems.item_count) {
        <app-slider
          [items]="data.feedItems.items"
          [itemTemplate]="newItemTemplate"
          sliderClass="-mr-4 md:-mr-8 pr-4 md:pr-8"
          [titleText]="'dashboardHome.whatsNew' | transloco"
        ></app-slider>

        <ng-template #newItemTemplate [templateType]="itemTemplateType" let-item>
          <button class="flex flex-col bg-white cursor-pointer rounded-md min-w-72 max-w-72 sm:last:mr-0 sm:min-w-96 sm:max-w-96" draggable="false" (click)="openWhatsNewDialog(item.title)">
            <img class="h-60 rounded-t-md" [src]=item.headline_asset.public_asset_url alt="" draggable="false">
            <div class="flex-1 flex items-center gap-2 sm:gap-3 p-4">
              <p [title]="item.title" class="text-sm sm:text-md">
                {{ item.title | truncate }}
              </p>
              <div>
                <div class="rounded-full border w-8 h-8 sm:w-10 sm:h-10 content-center">
                  <span><i class="pi pi-arrow-right" style="font-size: 0.75rem;"></i></span>
                </div>
              </div>
            </div>
          </button>
        </ng-template>
      } @else {
        <div class="w-[calc(100%+--spacing(16))] -ml-8 -mt-8">
          <img class="w-full" src="assets/images/hero-jcb-welcome.svg" alt="">
        </div>
      }
    </div>

    @if (hasRecentlyViewedItems) {
      <app-recently-viewed/>
    }

    <div>
      <h2 class="font-bold mb-4 md:text-lg">{{ 'dashboardHome.machineRange' | transloco }}</h2>

      <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-6 gap-6">
        @for (range of data.contentList.content; track range.id) {
          <a class="cursor-pointer block min-w-0 overflow-hidden" routerLink="/machine-range/{{ range.id }}">
            <img class="block w-full aspect-square object-cover rounded-md" [src]=range.thumbnail.public_asset_url alt="">
            <span [title]="range.name" class="block w-full font-bold mt-3 wrap-break-word hyphens-auto">{{ range.name | truncate: 50 }}</span>
          </a>
        }
      </div>
    </div>
  </div>
}
